import { Injectable } from '@angular/core';
import { ApiHttpClient } from '../../http/clients/api';
import { Observable } from 'rxjs';
import { Chat } from './chat.model';
import { environment } from 'environments/environment';

@Injectable({
    providedIn: 'root'
})
export class ChatService {

    constructor(private http: ApiHttpClient) { }

    // gets all notes for a borrower by borrowerId
    getBorrowerChats(borrowerId: number): Observable<Chat[]> {
        const query = encodeURIComponent(
            JSON.stringify({
                criteria: {
                    'chats.borrowerId': { '==': borrowerId }
                }
            })
        );
        return this.http.get<Chat[]>(`${environment.API_URL}/chat?query=${query}`);
    }
}
